import React, { useEffect, useState } from 'react';
import {
    TextField, MenuItem, Button, FormControlLabel, Switch,
    Typography, Box, Select, InputLabel, FormControl,Autocomplete
} from '@mui/material';
import axios from 'axios';
import { api } from '../api/client';
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";

const KayitTuruOptions = ['Schengen', 'ABD', 'İngiltere'];
const VizeTuruOptions = ['MULTI', 'SINGLE'];

const VizeKayitForm = () => {
    const [formData, setFormData] = useState({
        personal_id: '',
        baslangic: '',
        bitis: '',
        kayit_turu: '',
        sigorta: false,
        not:'',
        passport_no:'',
        gun_sayisi:'',
        vize_turu:''
    });
    const [dialogOpen, setDialogOpen] = useState(false);

    const [personelList, setPersonelList] = useState([]);

    useEffect(() => {
        api.get('/lookups/users', { params: { scope: 'liste' } })
            .then((response) => setPersonelList(response.data))
            .catch((error) => console.error('Personel verisi alınamadı:', error));
    }, [!personelList]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/vizeler', { ...formData, note: formData.not });
            //alert(response.data.message);
            window.location.reload();
        } catch (error) {
            alert('Kayıt sırasında hata oluştu.');
            console.error(error);
        }
    };

    return (


        <Box  >
            <Button onClick={()=>{setDialogOpen(true)}} variant={"contained"} style={{padding: '10px', margin:'20px'}} >
                Vize Kaydı Ekle
            </Button>
            <Dialog open={dialogOpen} onClose={() => {setDialogOpen(false)} } fullWidth>
                <DialogTitle>Kayıt Düzenle</DialogTitle>
                <DialogContent>
            <Typography variant="h5" gutterBottom>Yeni Kayıt</Typography>

                    <Autocomplete
                        options={personelList}
                        getOptionLabel={(option) => `${option.isim} ${option.soyisim}`}
                        value={
                            personelList.find(p => p.id === formData.personal_id) || null
                        }
                        onChange={(event, newValue) => {
                            handleChange({
                                target: {
                                    name: 'personal_id',
                                    value: newValue?.id || '',
                                }
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Personel"
                                margin="normal"
                                fullWidth
                            />
                        )}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Pasaport No"
                        name="passport_no"
                        value={formData.passport_no}
                        onChange={handleChange}
                    >

                    </TextField>
            <TextField
                fullWidth
                margin="normal"
                label="Başlangıç Tarihi"
                type="date"
                name="baslangic"
                InputLabelProps={{ shrink: true }}
                value={formData.baslangic}
                onChange={handleChange}
            />

            <TextField
                fullWidth
                margin="normal"
                label="Bitiş Tarihi"
                type="date"
                name="bitis"
                InputLabelProps={{ shrink: true }}
                value={formData.bitis}
                onChange={handleChange}
            />

            <TextField
                fullWidth
                select
                margin="normal"
                label="Vize Bölgesi"
                name="kayit_turu"
                value={formData.kayit_turu}
                onChange={handleChange}
            >
                {KayitTuruOptions.map((option) => (
                    <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
            </TextField>
           <TextField
                        fullWidth
                        select
                        margin="normal"
                        label="Vize Türü"
                        name="vize_turu"
                        value={formData.vize_turu}
                        onChange={handleChange}
                    >
               {VizeTuruOptions.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
            </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Gun"
                        name="gun_sayisi"
                        value={formData.gun_sayisi}
                        onChange={handleChange}
                    >

                    </TextField>

            <TextField
                fullWidth
                margin="normal"
                label="Not"
                name="not"
                value={formData.not}
                onChange={handleChange}
            >

            </TextField>
            <FormControlLabel
                control={
                    <Switch
                        checked={formData.sigorta}
                        onChange={handleChange}
                        name="sigorta"
                    />
                }
                label="Sigorta"
            />


                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {setDialogOpen(false)}}>İptal</Button>
                    <Button onClick={handleSubmit} variant="contained">Kaydet</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default VizeKayitForm;